// Keep saved permissions distinct from their currently effective access.
export const pipelinePermission = pipeline => pipeline?.manage || pipeline?.legacyManagement
  ? "manage" : pipeline?.enabled ? "use" : "none";

export const pipelineShareChange = (spaceId, permission) => ({
  spaceId, enabled: permission === "use" || permission === "manage",
  ...(permission === "manage" ? { manage: true } : {}),
});
